module.exports = __webpack_public_path__ + "static2023-4-17/img/send-month.1ea9cfeb.png";